module.exports = __webpack_public_path__ + "static/img/80-3.92baf9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/80-3.jpg
// module id = aKld
// module chunks = 0